var e = function e(_e, t) {
  return {
    value: _e,
    done: t
  };
};
export { e as c };